module.exports = __webpack_public_path__ + "img/docker-cli-xome-register.564cacab.png";